<script setup lang="ts">
import { closeDialog } from '@/components/modal/modal';
import { useFilters } from '@/elements';
import { euroWithZero } from '@/helpers';
import { computed } from 'vue';

import type { BookingDetails } from '@/types/form';
import type { RoomAndPrice } from '@/types/room';

const form = defineModel<BookingDetails>('form', { required: true });

const { searchParams } = useFilters();

defineProps<{ 
  current: RoomAndPrice;
  persons: number;
  accommodations: RoomAndPrice[];
}>();

const emit = defineEmits<{ (e: 'update:form', value: BookingDetails): void }>()

function handleSumbit() {
  const url = new URL(window.location.href);

  searchParams.value?.set('room_id', form.value.room_id);

  window.history.replaceState({}, '', `${url.pathname}?${searchParams.toString()}`);

  emit('update:form', form.value);
  closeDialog();
}

const morePrice = computed(() => (one: number, two: number, p: number = 0) => (one - two) / p);
</script>

<template>
  <div class="modal">
    <h3 class="modal__title">Selecteer de gewenste kamer</h3>
    <template v-if="accommodations.length === 0">
      <p class="text--center">Geen accommodaties gevonden</p>
    </template>
    <template v-else>
      <template v-for="({ room, price }, index) in accommodations" :key="index"> 
        <label :for="room.name">
          <div class="accommodation__input">
            <div class="checkmark">
              <!-- Change name to a static value like 'accommodation' to group the radios -->
              <input class="checkmark-circle" type="radio" name="accommodation" :id="room.name" :value="room.id" v-model="form.room_id" />
              <p class="description">{{ room.name }}</p>
            </div>

            <p class="title">
              <template v-if="morePrice(price, current.price, persons) === 0">
                Geen toeslag
              </template>
              <template v-else-if="morePrice(price, current.price, persons) < 0">
                {{ euroWithZero.format(morePrice(price, current.price, persons)) }} p.p.
              </template>
              <template v-else>
                {{ '+ ' + euroWithZero.format(morePrice(price, current.price, persons)) }} p.p.
              </template>
            </p>
          </div>
        </label>
      </template>
    </template>
    <hr>
    <div class="__footer">
      <a class="button link" @click.prevent="closeDialog()">Annuleer</a>
      <button class="button" @click.prevent="handleSumbit()">Selecteer</button>
    </div>
  </div>
</template>